/* eslint-disable camelcase */
import { Accordion, AccordionDetails, Button, Card, CardActions, CardContent, Divider, Grid, Stack, Tooltip } from '@mui/material'
import { styled } from '@mui/material/styles'
import AgriAction from 'agriAdministration/actions/AgriAction'
import ProgressBar from 'components/progress/ProgressBar'
import { push } from '@lagunovsky/redux-react-router'
import MatEventModal from 'exploitations/components/modal/MatEventModal'
import InstallationAction from 'installation/actions/InstallationAction'
import { compact, groupBy, keys, orderBy, uniq, uniqBy } from 'lodash'
import VariousMaterielAction from 'materiel/components/variousMateriel/actions/VariousMaterielAction'
import React, { Fragment, useEffect, useMemo, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import CultureAction from 'referencial/components/cultures/actions/CultureAction'
import CulturesFamilyAction from 'referencial/components/culturesFamilies/actions/CulturesFamilyAction'
import UsageAction from 'referencial/components/usage/actions/UsageAction'
import i18n from 'simple-react-i18n'
import DtoSamplingPointDecla from 'survey/dto/DtoSamplingPointDecla'
import { getDate } from 'utils/DateUtil'
import { hasValue } from 'utils/NumberUtil'
import { getSetting } from 'utils/SettingUtils'
import { formatMilliers } from 'utils/StringUtil'
import ModalIndex from './modals/ModalIndex'
import ModalUsage from './modals/ModalUsage'
import moment from 'moment'
import { AccordionTitle } from 'components/styled/Accordions'
import ProgressCard from 'components/card/ProgressCard'
import { useParams } from 'react-router'
import useTitle from 'utils/customHook/useTitle'
import { Check, DoNotDisturb, History, InvertColors, People, Warning } from '@mui/icons-material'
import { mainBlue } from 'utils/constants/ColorTheme'
import { CardTitle } from 'components/card/NewCard'
import { DECLARATION_STATUS, SURVEY_STATUS, SURVEY_TYPES, USAGES_CATEGORY } from 'agriAdministration/constants/AgriConstants'
import { getChronicleIdMatPump } from '../../../exploitations/utils/AgriUtils'

const ChronicleItem = styled(Grid)({
    padding: '2px',
    textAlign: 'center',
})

const TYPE_ESTIM = 1
const TYPE_INDEX = 2

const DeclarationPointUsages = ({}) => {
    const [openModalUsage, setOpenModalUsage] = useState(false)
    const [usageToUpdate, setUsageToUpdate] = useState()
    const [point, setPoint] = useState({})
    const [dataLoaded, setDataLoaded] = useState(false)
    const [declarationLoaded, setDeclarationLoaded] = useState(false)
    const [openModalIndex, setOpenModalIndex] = useState(false)
    const [selectedMaterial, setSelectedMaterial] = useState()
    const [consoType, setConsoType] = useState()
    const [openModalEvent, setOpenModalEvent] = useState(false)
    const [selectedEvent, setSelectedEvent] = useState()
    const [showAllConso, setShowAllConso] = useState(false)

    const {
        cultures,
        usages,
        installation,
        declaration,
        variousMateriels,
        exploitation,
        survey,
        matEventsExploitation,
        matEventsTypes,
        surveyVolumesExploitation,
        contributorsIndex,
        accountUser,
    } = useSelector(store => ({
        cultures: store.CultureReducer.cultures,
        usages: store.UsageReducer.usages,
        installation: store.InstallationReducer.installation,
        declaration: store.AgriReducer.declaration,
        variousMateriels: store.VariousMaterielReducer.variousMateriels,
        exploitation: store.AgriReducer.exploitation,
        survey: store.AgriReducer.survey,
        matEventsExploitation: store.VariousMaterielReducer.matEventsExploitation,
        matEventsTypes: store.VariousMaterielReducer.matEventsTypes,
        surveyVolumesExploitation: store.AgriReducer.surveyVolumesExploitation,
        contributorsIndex: store.ContributorReducer.contributorsIndex,
        accountUser: store.HomeReducer.accountUser,
    }), shallowEqual)

    const dispatch = useDispatch()
    const params = useParams()

    const real = useMemo(() => params?.type === 'reel', [params])
    const idInstallation = useMemo(() => parseInt(params?.idPoint), [params])
    const readMode = useMemo(() => survey?.statusCode === SURVEY_STATUS.ARCHIVED || declaration.statusCode >= DECLARATION_STATUS.VALIDATED || accountUser?.consultant === '1', [survey, declaration, accountUser])
    const usagesCurrentYear = useMemo(() => point.link_usagesCurrent || [], [point])
    const usagesPrevi = useMemo(() => point.link_usages || [], [point])

    useTitle(() => [
        {
            title: i18n.planning,
            href: 'planning',
        }, {
            title: i18n.surveys,
            href: 'planning/surveys',
        }, {
            title: `${survey.name || ''} [${survey.year || ''}]`,
            href: `survey/${survey.idSurvey}`,
        }, {
            title: `${i18n.declaration} ${exploitation.codification}`,
            href: `survey/${survey.idSurvey}/declaration/${params.idDeclaration}/stepper/0`,
        }, {
            title: `${i18n.pointPrelevement} ${installation.code}${installation.location ? ` - ${installation.location}` : ''}`,
            href: `survey/${survey.idSurvey}/declaration/${params.idDeclaration}/point/${params.idPoint}`,
        },
    ], [installation, exploitation])

    const setDeclaration = () => {
        dispatch(AgriAction.fetchDeclaration(params.idDeclaration)).then((res) => {
            dispatch(VariousMaterielAction.fetchMatEventsByExploitation(res.idExploitation))
            dispatch(InstallationAction.fetchInstallation(idInstallation)).then(() => {
                setPoint(res ? res.link_declarationInstallation.find((p) => p.idInstallation === idInstallation) : new DtoSamplingPointDecla({}))
                setDeclarationLoaded(true)
                if (real) {
                    dispatch(AgriAction.calculSurveyExploitationVolumes(survey.idSurvey, res.idDeclaration ? res.idExploitation : declaration.idExploitation))
                }
            })
        })
    }

    useEffect(() => {
        dispatch(CulturesFamilyAction.fetchCulturesFamilies()).then(() => {
            dispatch(CultureAction.fetchCultures()).then(() => {
                dispatch(AgriAction.fetchModesIrrigations()).then(() => {
                    // eslint-disable-next-line max-nested-callbacks
                    dispatch(UsageAction.fetchUsages()).then(() => {
                        setDataLoaded(true)
                    })
                })
            })
        })
        dispatch(AgriAction.fetchExploitationUser()).then(() => {
            setDeclaration()
        })
    }, [])

    const getMateriels = () => {
        const link_equipments = declaration.link_declarationInstallation.find((p) => p.idInstallation === idInstallation).link_equipments || []
        const newMats = link_equipments.filter((mLink) => !mLink.idMatAttachment && mLink.mode !== 'd')
        const deletedMats = link_equipments.filter((mLink) => !mLink.idMatAttachment && mLink.mode === 'd')
        const deletedCounters = link_equipments.filter((mLink) => mLink.idMatAttachment && mLink.mode === 'd')
        const exploitationPumps =
            declaration.link_exploitationMateriel.filter((m) => m.siteType === 7 && m.siteCode === idInstallation && !deletedMats.find((mLink) => m.idVarious === mLink.idMat))
            || []
        const mergedPumpsIds = uniqBy([
            ...exploitationPumps.map((m) => m.idVarious),
            ...newMats.map((m) => m.idMat),
        ], obj => obj)
        const exploitationCountersId = compact(mergedPumpsIds.flatMap((pumpId) => {
            const pumpSitu = declaration.link_exploitationMateriel.filter((situ) => situ.siteType === 8 && situ.siteCode === pumpId && !deletedCounters.find((mLink) => pumpId === mLink.idMat))
            if (pumpSitu) {
                return pumpSitu.map((s) => s.idVarious)
            }
            return null
        }))
        const newCounters = link_equipments.filter((mLink) => mLink.idMatAttachment && mLink.mode !== 'd' && mergedPumpsIds.includes(mLink.idMat))
        const mergedCountersIds = uniqBy([
            ...exploitationCountersId,
            ...newCounters.map((m) => m.idMatAttachment),
        ], obj => obj)
        const materiels = variousMateriels.filter((m) => [...mergedPumpsIds, ...mergedCountersIds].includes(m.id) && (!hasValue(m.administrator) || m.administrator === exploitation.operatorCode))
        return { pumpsIds: mergedPumpsIds, countersIds: mergedCountersIds, materiels }
    }

    const onSaveUsage = (newUsages) => {
        const newPoints = declaration.link_declarationInstallation.filter(
            (p) => p.idInstallation !== point.idInstallation,
        )
        if (real) {
            newPoints.push({
                ...point,
                link_usagesCurrent: newUsages,
            })
        } else {
            newPoints.push({
                ...point,
                link_usages: newUsages,
            })
        }
        const updateDeclaration = {
            ...declaration,
            lastStep: declaration.lastStep >= 3 ? declaration.lastStep : 3,
            link_declarationInstallation: newPoints,
        }
        setDeclarationLoaded(false)
        dispatch(AgriAction.updateDeclaration(updateDeclaration)).then(() => {
            setDeclaration()
        })
        setOpenModalUsage(false)
    }

    const onCancelUsage = () => setOpenModalUsage(false)

    const getListUsages = (current, agri) => {
        const usagesSelected = current ? usagesCurrentYear : usagesPrevi
        const filteredUsages = compact(usagesSelected.map((u) => {
            const usageCat = usages.find((uCat) => uCat.idUsage === u.idUsage)
            if (usageCat && (agri ? usageCat.category === USAGES_CATEGORY.AGRI : usageCat.category !== USAGES_CATEGORY.AGRI)) {
                return u
            }
            return null
        }))

        const total = filteredUsages.length ? filteredUsages.reduce((acc, u) => acc + (isNaN(u.requestedYearVolume) ? 0 : u.requestedYearVolume), 0) : 0
        return (
            <Grid size={6} sx={{ padding: '10px' }}>
                <Accordion
                    defaultExpanded
                    sx={{
                        border: '1px solid',
                        borderColor: 'primary.main',
                        borderRadius: 2,
                    }}
                >
                    <AccordionTitle
                        title={!real ? `${agri ? i18n.agri : i18n.nonAgri} : ${formatMilliers(total) || 0} m3` : agri ? i18n.agri : i18n.nonAgri}
                        color={mainBlue}
                    />
                    <AccordionDetails>
                        <Grid
                            container
                            direction='column'
                            justifyContent='center'
                        >
                            {!filteredUsages?.length && i18n.noUsage}
                            {filteredUsages.map((u) => {
                                const culture = cultures.find((c) => c.id === u.idCulture)
                                const usageCat = usages.find((uCat) => uCat.idUsage === u.idUsage)
                                return (
                                    <Grid
                                        key={u.id}
                                        container
                                        direction='column'
                                        justifyContent='center'
                                        sx={{ borderBottom: 'solid black 1px' }}
                                        className={readMode ? '' : 'clickable'}
                                        onClick={readMode ? () => {} : () => {
                                            setUsageToUpdate(u)
                                            setOpenModalUsage(true)
                                        }}
                                    >
                                        <>
                                            {agri ? (
                                                <Grid sx={{ fontWeight: 'bold' }}>
                                                    {`${usageCat.description} ${usageCat.category === 1 && culture ? `/ ${culture.name}` : ''}`}
                                                </Grid>
                                            ) : (
                                                <Grid sx={{ fontWeight: 'bold' }}>{usageCat.description}</Grid>
                                            )}
                                            {!real && (
                                                <Grid>
                                                    {`${usageCat.isCulture ? i18n.indicativeSimu : i18n.askedLabel} : ${formatMilliers(u.requestedYearVolume) || 0} m3${hasValue(u.area) ? ` - ${u.area} ha` : ''} ${hasValue(u.lowWaterVolume) ? `(${i18n.volumeLowWater} : ${formatMilliers(u.lowWaterVolume)} m3)` : ''}`}
                                                </Grid>
                                            )}
                                            {real && (hasValue(u.requestedYearVolume) || hasValue(u.area))&& (
                                                <Grid>
                                                    {hasValue(u.requestedYearVolume) ?
                                                        `${i18n.volume} : ${formatMilliers(u.requestedYearVolume) || 0} m3${hasValue(u.area) ? ` - ${u.area} ha` : ''} ${hasValue(u.lowWaterVolume) ? `(${i18n.volumeLowWater} : ${formatMilliers(u.lowWaterVolume)} m3)` : ''}`
                                                        : hasValue(u.area) ? `${u.area} ha` : ''}
                                                </Grid>
                                            )}
                                        </>
                                    </Grid>
                                )
                            })}
                        </Grid>
                    </AccordionDetails>
                </Accordion>
            </Grid>
        )
    }

    const onValideUsage = () => {
        dispatch(push(`/survey/${params.id}/declaration/${params.idDeclaration}/point/${idInstallation}`))
    }

    const editModalIndex = (type, id) => {
        setSelectedMaterial(id)
        setConsoType(type)
        setOpenModalIndex(true)
    }

    const getEvolValue = (type, chronicles, chronicle, index) => {
        if (type === TYPE_INDEX) {
            return chronicle.value - chronicles[index + 1].value
        }
        return Math.round(chronicles.slice(index).reduce((acc, d) => acc + d.value, 0))
    }

    const getChroniclesByType = (chroniclesByType, type, materiel, readingCoefficient = 1, shared) => {
        if (chroniclesByType?.length) {
            const orderedChronicles = orderBy(chroniclesByType, ['measureDate', 'endDate', 'value'], ['desc', 'desc', 'desc'])
            const props = {
                onClick: (readMode || shared) ? () => {} : () => editModalIndex(type, materiel.id),
            }
            return (
                <>
                    <ChronicleItem className='italic-label' size={3} {...props}>
                        {type === TYPE_ESTIM ? i18n.startDate : i18n.statementDate}
                    </ChronicleItem>
                    <ChronicleItem className='italic-label' size={3} {...props}>
                        {type === TYPE_ESTIM ? i18n.endDate : ''}
                    </ChronicleItem>
                    <ChronicleItem className='italic-label' size={3} {...props}>
                        {type === TYPE_ESTIM ? i18n.estimateM3 : i18n.index}
                    </ChronicleItem>
                    <ChronicleItem className='italic-label' size={3}>
                        {type === TYPE_ESTIM ? i18n.stack : i18n.evolution}
                    </ChronicleItem>
                    {orderedChronicles.map((chronicle, i) => {
                        if (!showAllConso && i >= 10) {
                            return null
                        }
                        if (chronicle.event) {
                            const onClickEvent = ({
                                onClick: () => {
                                    if (readMode || shared) {
                                        setSelectedEvent(chronicle)
                                        setOpenModalEvent(true)
                                    }
                                },
                            })
                            return (
                                <Fragment key={i}>
                                    <ChronicleItem size={3} {...onClickEvent}>
                                        {getDate(chronicle.measureDate)}
                                    </ChronicleItem>
                                    <ChronicleItem size={3} {...onClickEvent}>
                                        {(matEventsTypes.find(({ id }) => id === chronicle.idType) || {}).name || ''}
                                    </ChronicleItem>
                                    <Tooltip title={chronicle.comment} placement='bottom'>
                                        <ChronicleItem size={3} {...onClickEvent}><Warning /></ChronicleItem>
                                    </Tooltip>
                                    <ChronicleItem size={3} {...onClickEvent} />
                                </Fragment>
                            )
                        }
                        const valueEvol = i !== orderedChronicles.length - 1 ? getEvolValue(type, orderedChronicles, chronicle, i) : null
                        return (
                            <Fragment key={i}>
                                <ChronicleItem size={3} {...props}>
                                    {getDate(chronicle.measureDate)}
                                </ChronicleItem>
                                <ChronicleItem size={3} {...props}>
                                    {chronicle.endDate ? getDate(chronicle.endDate) : ''}
                                </ChronicleItem>
                                <ChronicleItem size={3} {...props}>
                                    {`${formatMilliers(chronicle.value) || 0}${chronicle.measureType === 1 ? ' m3' : ''}`}
                                </ChronicleItem>
                                <ChronicleItem size={3} sx={ valueEvol < 0 ? { color: 'orange' } : {}}>
                                    {hasValue(valueEvol) ? ` ${valueEvol < 0 ? '-' : '+'} ${formatMilliers(Math.abs((valueEvol) * readingCoefficient))} m3` : ''}
                                </ChronicleItem>
                            </Fragment>
                        )
                    })}
                    <ChronicleItem size={11}>
                        <Divider />
                    </ChronicleItem>
                </>
            )
        }
        return null
    }

    const getChronicles = (pointEventsFormatted) => {
        const { pumpsIds, countersIds } = getMateriels()
        const allIds = [...pumpsIds, ...countersIds]
        const linkPoint = exploitation.link_samplings.find((l) => l.idInstallation === point.idInstallation) || {}
        const groupedByMat = Object.values(groupBy([...declaration.link_chronicles, ...pointEventsFormatted].filter((c) => allIds.includes(c.idMat) && (!linkPoint.startDate || c.measureDate >= linkPoint.startDate) && (!linkPoint.endDate || c.measureDate < linkPoint.endDate)), 'idMat'))
        return compact(groupedByMat.map((chronicles) => {
            const variousMat = variousMateriels.find((mat) => mat.id === chronicles[0].idMat) || {}
            const shared = hasValue(variousMat.administrator) && variousMat.isShared
            if (!hasValue(variousMat.administrator) || (variousMat.administrator === exploitation.operatorCode) || variousMat.isShared) {
                const indexChronicles = chronicles.filter((c) => c.measureType === TYPE_INDEX || c.event)
                const estimateChronicles = chronicles.filter((c) => c.measureType === TYPE_ESTIM)
                const counterUpdated = declaration.link_counters.find((c) => c.id === variousMat.id) || {}
                const readingCoefficient = counterUpdated.readingCoefficient || variousMat?.counter?.readingCoefficient
                const ordered = orderBy(indexChronicles.filter((c) => !c.event), ['measureDate', 'endDate', 'value'], ['desc', 'desc', 'desc'])
                const evol = ordered.length > 1 ? (ordered[0].value - ordered[ordered.length - 1].value) * (readingCoefficient || 1) : 0
                return {
                    evol,
                    content: (
                        <Grid
                            size={12}
                            container
                            direction='row'
                            justifyContent='center'
                            className={(readMode || shared) ? '' : 'clickable'}
                        >
                            <ChronicleItem
                                size={11}
                                className='bold'
                                container
                                alignItems='center'
                                onClick={(readMode || shared) ? () => {} : () => editModalIndex(chronicles[0].measureType, variousMat.id)}
                            >
                                {variousMat.reference}{readingCoefficient ? ` - ${i18n.readingCoefficient} ${readingCoefficient}` : ''}
                                {variousMat?.counter?.informative && ` (${i18n.informative})`}
                                {shared && (
                                    <Tooltip title={`${i18n.shared} (${i18n.administrator} : ${contributorsIndex[variousMat.administrator]?.name})`}>
                                        <People />
                                    </Tooltip>
                                )}
                            </ChronicleItem>
                            {getChroniclesByType(indexChronicles, TYPE_INDEX, variousMat, readingCoefficient, shared)}
                            {getChroniclesByType(estimateChronicles, TYPE_ESTIM, variousMat, 1, shared)}
                        </Grid>
                    ),
                }
            }
            return null
        }))
    }

    const getAccordeon = (pointEventsFormatted, pumpsIds, countersIds) => {
        const titleConsos = `${i18n.consos} ${survey.surveyType === SURVEY_TYPES.INTERMEDIATE ? survey?.year : survey?.year - 1}`
        const chronicles = getChronicles(pointEventsFormatted)
        const evolTotal = surveyVolumesExploitation.find((v) => v.idInstallation === idInstallation)?.total
        return (
            <Grid size={12} sx={{ padding: '10px' }}>
                <Accordion
                    defaultExpanded
                    sx={{
                        border: '1px solid',
                        borderColor: 'primary.main',
                        borderRadius: 2,
                    }}
                >
                    <AccordionTitle
                        title={`${titleConsos} | ${i18n.totalRealVolume} : ${formatMilliers(evolTotal)} m3`}
                        color={mainBlue}
                    />
                    <AccordionDetails>
                        <Grid
                            container
                            direction='row'
                            justifyContent='center'
                            spacing={1}
                        >
                            {chronicles.map(c => c.content)}
                            {![...pumpsIds, ...countersIds].length ? (
                                <p>{i18n.noEquipmentOnPoint}</p>
                            ) : (
                                <Grid size={2}>
                                    <Button
                                        variant='contained'
                                        color='primary'
                                        onClick={() => setOpenModalIndex(true)}
                                        disabled={readMode}
                                        sx={{ height: '100%', width: '100%' }}
                                        endIcon={<InvertColors />}
                                    >
                                        {i18n.addConso}
                                    </Button>
                                </Grid>
                            )}
                            <Grid size={2}>
                                <Button
                                    variant='contained'
                                    color='primary'
                                    onClick={() => setOpenModalEvent(true)}
                                    disabled={readMode}
                                    sx={{ height: '100%', width: '100%' }}
                                    endIcon={<Warning />}
                                >
                                    {i18n.addOneEvent}
                                </Button>
                            </Grid>
                            <Grid size={2}>
                                <Button
                                    variant='contained'
                                    color='primary'
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        setShowAllConso(!showAllConso)
                                    }}
                                    sx={{ height: '100%', width: '100%' }}
                                    endIcon={<History />}
                                >
                                    {showAllConso ? i18n.showLessHistory : i18n.showMoreHistory}
                                </Button>
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                </Accordion>
            </Grid>
        )
    }

    const getContent = () => {
        const { pumpsIds, countersIds } = getMateriels()
        const eventsMat = matEventsExploitation.filter(({ idMateriel }) => [...pumpsIds, ...countersIds].includes(idMateriel))
        const pointEvents = eventsMat.filter(({ eventDate }) => {
            const yearEvent = new Date(eventDate).getFullYear()
            return yearEvent === survey.year || yearEvent === survey.year - 1
        })
        const pointEventsFormatted = pointEvents.map((e) => {
            return {
                ...e,
                idMat: e.idMateriel,
                measureDate: e.eventDate,
                event: true,
            }
        })

        if (!real) {
            return (
                <Grid
                    container
                    justifyContent='center'
                    size={12}
                >
                    {getListUsages(false, true)}
                    {getListUsages(false, false)}
                </Grid>
            )
        }
        return (
            <>
                <Grid
                    container
                    justifyContent='center'
                    size={12}
                >
                    {getListUsages(true, true)}
                    {getListUsages(true, false)}
                </Grid>
                {(getSetting(survey.link_params, 'consos') || '1') !== '0' && getAccordeon(pointEventsFormatted, pumpsIds, countersIds)}
            </>
        )
    }

    const onCancelIndex = () => {
        setConsoType()
        setSelectedMaterial()
        setOpenModalIndex(false)
    }

    const onSaveIndex = (link_chronicles) => {
        const updateDeclaration = {
            ...declaration,
            lastStep: declaration.lastStep >= 3 ? declaration.lastStep : 3,
            link_chronicles,
        }
        setDeclarationLoaded(false)
        onCancelIndex()
        dispatch(AgriAction.updateDeclaration(updateDeclaration)).then(() => {
            setDeclaration()
        })
    }

    const onCancelEvent = () => {
        setOpenModalEvent(false)
        setSelectedEvent()
    }

    const onValidateEvent = (event) => {
        onCancelEvent()
        if (event.id) {
            dispatch(VariousMaterielAction.updateMatEvent(event,
                () => dispatch(VariousMaterielAction.fetchMatEventsByExploitation(exploitation.idExploitation)),
            ))
        } else {
            dispatch(VariousMaterielAction.createMatEvent(event,
                () => dispatch(VariousMaterielAction.fetchMatEventsByExploitation(exploitation.idExploitation)),
            ))
        }
    }

    const onDeleteEvent = (event) => {
        onCancelEvent()
        dispatch(VariousMaterielAction.deleteMatEvent(event.id,
            () => dispatch(VariousMaterielAction.fetchMatEventsByExploitation(exploitation.idExploitation)),
        ))
    }

    const onClickNoConso = () => {
        const { materiels, pumpsIds } = getMateriels()
        const pointToRemove = declaration.link_declarationInstallation.find((p) => p.idInstallation === point.idInstallation)
        const points = declaration.link_declarationInstallation.filter(
            (p) => p.idInstallation !== point.idInstallation,
        )
        points.push({
            ...pointToRemove,
            link_usagesCurrent: [],
        })
        const date = moment().valueOf()
        const matsIds = materiels.map((m) => m.id)
        const chroniclesByMat = groupBy(declaration.link_chronicles.filter((c) => c.measureType === TYPE_INDEX && matsIds.includes(c.idMat)), 'idMat')
        const indexs = compact(keys(chroniclesByMat).map((matId) => {
            const lastIndex = orderBy(chroniclesByMat[matId], 'measureDate', 'desc')[0]
            if (lastIndex && lastIndex.measureDate < date) {
                return { matId, value: orderBy(chroniclesByMat[matId], 'measureDate', 'desc')[0]?.value }
            }
            return undefined
        }))
        const newIndexs = indexs.map((i) => ({
            matType: 'divers',
            idMat: Number(i.matId),
            measureType: TYPE_INDEX,
            measureDate: date,
            value: i.value,
            idInstallation: point.idInstallation,
            idMatPump: getChronicleIdMatPump(Number(i.matId), pumpsIds, declaration.link_exploitationMateriel, pointToRemove?.link_equipments),
            idExploitation: declaration.idExploitation,
            new: true,
        }))
        const newDeclaration = {
            ...declaration,
            lastStep: declaration.lastStep >= 3 ? declaration.lastStep : 3,
            link_declarationInstallation: points,
            link_chronicles: [
                ...declaration.link_chronicles,
                ...newIndexs,
            ],
        }
        dispatch(AgriAction.updateDeclaration(newDeclaration)).then(() => {
            dispatch(push(`/survey/${params.id}/declaration/${params.idDeclaration}/point/${idInstallation}`))
        })
    }

    const title = !real ? i18n.nbPtPrevi : i18n.nbPtReal
    if (declarationLoaded) {
        const { pumpsIds, countersIds, materiels } = getMateriels()
        const exploitationMatIds = materiels.map(({ id }) => id)
        const showButtonAddUse = (real && (getSetting(survey.link_params, 'usagesReal') || '1') !== '0') || (!real && (getSetting(survey.link_params, 'usagesPrevi') || '1') !== '0')
        return (
            <Stack padding={1}>
                <Card>
                    <CardTitle
                        title={title}
                        actions={[
                            {
                                icon: 'note_add',
                                onClick: () => {
                                    setOpenModalUsage(true)
                                    setUsageToUpdate()
                                },
                                displayed: showButtonAddUse && !readMode,
                                tooltip: !real ? i18n.addPrevUse : i18n.addUse,
                            },
                        ]}
                    />
                    <CardContent>
                        {dataLoaded && declarationLoaded ? (
                            getContent()
                        ) :
                            <Grid size={12} sx={{ padding: '10px' }}>
                                <ProgressBar indeterminate withMessage />
                            </Grid>
                        }
                    </CardContent>
                    <CardActions
                        sx={{
                            borderTop: '1px solid lightgrey',
                            justifyContent: 'center',
                        }}
                    >
                        {real && (
                            <Grid>
                                <Button
                                    variant='contained'
                                    onClick={onClickNoConso}
                                    disabled={readMode}
                                    endIcon={<DoNotDisturb />}
                                >
                                    {i18n.noSampling}
                                </Button>
                            </Grid>
                        )}
                        <Grid>
                            <Button
                                variant='contained'
                                onClick={onValideUsage}
                                endIcon={<Check />}
                            >
                                {!real ? i18n.validPrevUses : i18n.validUses}
                            </Button>
                        </Grid>
                    </CardActions>
                </Card>
                {openModalUsage && (
                    <ModalUsage
                        open={openModalUsage}
                        point={point}
                        usage={usageToUpdate}
                        usagesDeclaration={real ? usagesCurrentYear : usagesPrevi}
                        onSave={onSaveUsage}
                        onDelete={onSaveUsage}
                        onCancel={onCancelUsage}
                        currentYear={real}
                        countersId={countersIds}
                    />
                )}
                {openModalIndex && (
                    <ModalIndex
                        open={openModalIndex}
                        point={point}
                        pumpsId={uniq(pumpsIds.filter((id) => exploitationMatIds.includes(id)))}
                        countersId={uniq(countersIds.filter((id) => exploitationMatIds.includes(id)))}
                        selectedMaterial={selectedMaterial}
                        consoType={consoType}
                        onSave={onSaveIndex}
                        onCancel={onCancelIndex}
                    />
                )}
                {openModalEvent && (
                    <MatEventModal
                        open={openModalEvent}
                        defaultEvent={selectedEvent}
                        materiels={getMateriels().materiels}
                        onCancel={onCancelEvent}
                        onValidate={onValidateEvent}
                        onDelete={onDeleteEvent}
                    />
                )}
            </Stack>
        )
    }
    return (
        <Stack padding={1}>
            <ProgressCard indeterminate withMessage round />
        </Stack>
    )
}

export default DeclarationPointUsages
